export default __webpack_public_path__ + "static/media/cartow.ebfe5208.svg";